/* eslint-disable no-nested-ternary */
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { SectionCardItemSliderProps } from '..';
import { Button, CardItemSlider, LoadingContainer, Section, SectionTitle } from '..';
import * as Styled from './styled';

export * from './types';

export const SectionCardItemSlider: FC<SectionCardItemSliderProps> = (props) => {
  const { translate } = useTranslation();

  const {
    title,
    subtitle,
    onShowMoreClick,
    showMoreLink,
    showMoreText = translate('common.buttons.seeMore'),
    loading = false,
    centered = true,
    items = [],
    overrideSettings,
    children,
    whiteArrows = false,
    outlinedButtons = true,
  } = props;

  if (!loading && !items.length) return null;

  return (
    <Section centerChildren={centered}>
      {title &&
        (typeof title === 'string' ? (
          <SectionTitle dangerouslySetInnerHTML={{ __html: title }} />
        ) : (
          <SectionTitle>{title}</SectionTitle>
        ))}
      {subtitle &&
        (typeof subtitle === 'string' ? (
          <Styled.Subtitle centered={centered} dangerouslySetInnerHTML={{ __html: subtitle }} />
        ) : (
          <Styled.Subtitle centered={centered}>{subtitle}</Styled.Subtitle>
        ))}
      {loading ? (
        <LoadingContainer />
      ) : (
        <>
          {!items?.length ? null : (
            <CardItemSlider
              items={items}
              overrideSettings={overrideSettings}
              whiteArrows={whiteArrows}
            />
          )}
        </>
      )}

      {showMoreLink && (
        <Button color="blue" outlined={outlinedButtons} link={showMoreLink} shrink>
          {showMoreText}
        </Button>
      )}
      {onShowMoreClick && (
        <Button color="blue" outlined={outlinedButtons} shrink onClick={onShowMoreClick}>
          {showMoreText}
        </Button>
      )}
      {children}
    </Section>
  );
};
